<template>
  <div>
    <h4>Cartão de Crédito</h4>
    <PaymentProviderNotice
      variant="redirect"
      message="Você será redirecionado para o PayPal para concluir o pagamento com cartão de crédito. Permaneça nesta página."
    />
    <div v-show="!hasApprovalUrl">
      <CreditCardCustomerFields :basket="basket" />
    </div>

    <paypal-plus
      v-if="hasApprovalUrl && componentKey > 0"
      :key="componentKey"
      ref="ppplus"
      :mode="payPalMode"
      iframeHeight="430"
      :approvalUrl="approvalUrl"
      :firstName="basket.firstname"
      :lastName="basket.lastname"
      country="BR"
      :taxId="basket.cpfcnpj"
      :email="basket.email"
      :installmentTerm="1"
      :blockInstallment="false"
      @checkout="onContinue"
      @error="onError"
    />

    <vs-button type="relief" class="w-full mt-6" @click="next()" v-if="!hasApprovalUrl">Continuar</vs-button>
    <vs-button type="relief" class="w-full mt-6" @click="pay()" v-else>Pagar</vs-button>
  </div>
</template>

<script>
import CreditCardCustomerFields from '../CreditCardCustomerFields.vue';
import PaymentProviderNotice from '../PaymentProviderNotice.vue';
import PaypalPlus from 'paypalplus-for-vue';
import { cpf, cnpj } from 'cpf-cnpj-validator';

export default {
  components: {
    CreditCardCustomerFields,
    PaymentProviderNotice,
    PaypalPlus,
  },
  props: {
    checkoutWizard: {
      type: Object,
      required: true,
    },
    paymentMethod: {
      type: String,
      required: true,
    },
    basket: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      payPalMode: process.env.VUE_APP_PAYPAL_MODE,
      componentKey: 0,
      approvalUrl: null,
      paymentId: null,
    };
  },
  mounted() {
    if (window.addEventListener) {
      window.addEventListener('message', this.receiveMessage, false);
    } else if (window.attachEvent) {
      window.attachEvent('onmessage', this.receiveMessage);
    }
  },
  computed: {
    hasApprovalUrl() {
      return this.approvalUrl;
    },
  },
  methods: {
    next() {
      const cpfcnpj = this.basket.cpfcnpj.replace(/[^0-9]/g, '');
      const isDocumentValid = cnpj.isValid(cpfcnpj) || cpf.isValid(cpfcnpj);
      if (!isDocumentValid) {
        this.$vs.notify({
          time: 6000,
          text: 'O número do CPF/CNPJ está incorreto.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
        });
      } else if (isDocumentValid) {
        this.basket.processing = true;

        this.$api
          .post('/api/v1/checkout/order/create', {
            payment_method: this.paymentMethod,
            basket: this.basket,
            affiliate: localStorage.getItem('aff') || null,
          })
          .then((response) => {
            this.createData = response.data;
            this.approvalUrl = response.data.links[1].href;
            this.componentKey += 1;
            setTimeout(() => {
              this.basket.processing = false;
            }, 3000);
          })
          .catch((error) => {
            this.basket.processing = false;
            this.$EventBus.$emit('paymentProviderFailed', this.paymentMethod);
            let errors = [];
            if (error.response.data.message) {
              errors.push(error.response.data.message);
            } else {
              for (const key in error.response.data) {
                if (Object.hasOwnProperty.call(error.response.data, key)) {
                  const element = error.response.data[key];
                  errors.push(element);
                }
              }
            }
            this.$vs.notify({
              time: 6000,
              text: errors.join('<br>'),
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger',
            });
          });
      }
    },
    onContinue(data) {
      this.basket.processing = true;
      setTimeout(() => {
        this.basket.processing = true;
      }, 1000);

      this.$api
        .post('/api/v1/checkout/order/capture', {
          payment_method: this.paymentMethod,
          basket: this.basket,
          createData: this.createData,
          approvalData: data,
        })
        .then((response) => {
          if (response.data && parseInt(response.data.orderId) > 0) {
            window.location.href =
              '/checkout/complete?orderId=' + response.data.orderId + '&orderNumber=' + response.data.orderNumber;
          } else {
            this.basket.processing = false;

            this.$vs.notify({
              time: 10000,
              text: 'Não foi possível processar seu pedido. Atualize a página e tente novamente.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger',
            });
          }
        })
        .catch((error) => {
          this.componentKey += 1;

          this.basket.processing = false;
          this.$EventBus.$emit('paymentProviderFailed', this.paymentMethod);

          this.$vs.notify({
            time: 10000,
            text: error.response.data.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
          });
        });
    },
    onError(data) {
      let error = data.error;
      switch (error) {
        case 'TRY_ANOTHER_CARD':
          this.$vs.notify({
            time: 10000,
            text: 'Por favor, tente outro cartão.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
          });

          this.componentKey += 1;
          break;
        default:
          this.$vs.notify({
            time: 10000,
            text: 'Ocorreu um erro ao processar sua compra. Tente novamente.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
          });
      }
    },
    pay() {
      this.$refs.ppplus.pppContinue();
    },
    receiveMessage(event) {
      try {
        if (!event.data || !event.origin || (event.origin && event.origin.indexOf('paypal') === -1)) {
          return;
        }

        var message = JSON.parse(event.data);
        if (typeof message['cause'] !== 'undefined') {
          let ppplusError = message['cause'].replace(/['"]+/g, '');
          switch (ppplusError) {
            case 'INTERNAL_SERVICE_ERROR': //javascript fallthrough
            case 'SOCKET_HANG_UP': //javascript fallthrough
            case 'socket hang up': //javascript fallthrough
            case 'connect ECONNREFUSED': //javascript fallthrough
            case 'connect ETIMEDOUT': //javascript fallthrough
            case 'UNKNOWN_INTERNAL_ERROR': //javascript fallthrough
            case 'fiWalletLifecycle_unknown_error': //javascript fallthrough
            case 'Failed to decrypt term info': //javascript fallthrough
            case 'RESOURCE_NOT_FOUND': //javascript fallthrough
            case 'INTERNAL_SERVER_ERROR':
              this.$vs.notify({
                time: 20000,
                text: 'Ocorreu um erro inesperado, por favor tente novamente. (' + ppplusError + ')',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger',
              });
              break;

            case 'RISK_N_DECLINE': //javascript fallthrough
            case 'NO_VALID_FUNDING_SOURCE_OR_RISK_REFUSED': //javascript fallthrough
            case 'TRY_ANOTHER_CARD': //javascript fallthrough
            case 'NO_VALID_FUNDING_INSTRUMENT':
              this.$vs.notify({
                time: 20000,
                text: 'Seu pagamento não foi aprovado. Por favor utilize outro cartão, caso o problema persista entre em contato com o PayPal (0800-047-4482). (' +
                  ppplusError +
                  ')',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger',
              });
              break;

            case 'CARD_ATTEMPT_INVALID':
              this.$vs.notify({
                time: 20000,
                text: 'Ocorreu um erro inesperado, por favor tente novamente. (' + ppplusError + ')',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger',
              });
              break;

            case 'INVALID_OR_EXPIRED_TOKEN':
              this.$vs.notify({
                time: 20000,
                text: 'A sua sessão expirou, por favor tente novamente. (' + ppplusError + ')',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger',
              });
              break;

            case 'CHECK_ENTRY':
              this.$vs.notify({
                time: 20000,
                text: 'Por favor revise os dados de Cartão de Crédito inseridos. (' + ppplusError + ')',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger',
              });
              break;

            default:
              this.$vs.notify({
                time: 20000,
                text: 'Ocorreu um erro inesperado, por favor tente novamente. (' + ppplusError + ')',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger',
              });
          }
        }

        if (message['action'] == 'enableContinueButton') {
          this.basket.processing = false;
        }

        if (message['action'] == 'disableContinueButton') {
          this.basket.processing = true;
        }

        if (message['action'] == 'loaded') {
          this.ppplusDivStyle = {};
        }
      } catch (e) {
        // do nothing
      }
    },
  },
};
</script>

